<template>
  <div class="bg-white">
    <div v-if="!isLoading">
      <div class="tab-data__wrapper">
        <div v-if="dwolla
          && dwolla.accounts
          && !dwolla.accounts.length" class="tab-data__content no-top-border">
          <img class="mx-auto tab-data__img" src="@/assets/img/bank-connect.svg" alt="bank-connect" />
          <div class="connect-text text-center">
            {{ $t("bank-connect.text") }}
          </div>
          <div class="d-flex justify-content-center  mt-4">
            <CustomButton :name="$t('bank-connect.connect-bank')"
              className="tab-data__connect-bank__btn button-default-outline" @handle-click="getConnectBank()" />
          </div>
        </div>
        <div v-if="dwolla
          && dwolla.accounts
          && dwolla.accounts.length" class="tab-data__content no-top-border">
          <div class="pa-1">
            <div class="tab-data__connect-bank">
              <div>
                <div>
                  <div class="paywith d-flex">
                    <div class="paywith__text_blue">
                      <small>
                        {{ $t("payment.pay-with") }}
                      </small>
                    </div>
                    <div class="paywith__container">
                      <img class="m-0" :src="!selectedAccount.icon && selectedAccount.accountName
                        ? require('@/assets/img/wallets/bank.svg')
                        : selectedAccount.icon" :alt="selectedAccount.bankName" />
                      <span>{{ selectedAccount.bankName }}</span>
                    </div>
                    <div v-if="getFilteredAccounts && getFilteredAccounts.length" class="paywith__arrow"
                      @click="accountsListControl = !accountsListControl">
                      <div class="dropdown-arrow">
                        <img src="@/assets/img/arrow.svg" alt="arrow">
                      </div>
                    </div>
                  </div>
                  <b-collapse id="bank-collapse" v-model:open="accountsListControl">
                    <div class="paywith border p-2 pointer" v-for="(account, i) in getFilteredAccounts" :key="i"
                      @click="handelSelectAccount(account)">
                      <div class="d-flex">
                        <img class="mx-2" :src="require('@/assets/img/wallets/bank.svg')" :alt="account.bankName" />
                        <div>
                          <div class="paywith__bank-name">{{ account.bankName }}</div>
                          <div v-if="account.mask" class="paywith__account">
                            <span class="paywith__account-text"> Account Number - </span>
                            <span>
                              {{ account.mask ? 'XXXXXXXX' + account.mask : '' }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-data__content" v-if="dwolla
          && dwolla.accounts
          && dwolla.accounts.length">
          <div>
            <div class="paywith d-flex">
              <div class="paywith__text_orange">
                <small>
                  {{ $t("payment.choose-currency") }}
                </small>
              </div>
              <div class="paywith__container">
                <div class="d-flex align-items-center" v-if="selectedCurrency && Object.keys(selectedCurrency).length">
                  <img class="m-0" :src="selectedCurrency
                    && !selectedCurrency.icon
                    ? require('@/assets/img/wallets/bank.svg')
                    : selectedCurrency.icon" :alt="selectedCurrency.name" />
                  <span>{{ selectedCurrency.name }}</span>
                </div>
                <div v-else>
                  No curency found
                </div>
              </div>
              <div v-if="getFilteredCurrencies && getFilteredCurrencies.length" class="paywith__arrow"
                @click="currencyListControl = !currencyListControl">
                <div class="dropdown-arrow">
                  <img src="@/assets/img/arrow.svg" alt="arrow">
                </div>
              </div>
            </div>
            <b-collapse v-model:open="currencyListControl">
              <div class="paywith border pointer" v-for="(currency, i) in getFilteredCurrencies" :key="i"
                @click="handelSelectCurrency(currency)">
                <div class="paywith__currency d-flex align-items-center p-2">
                  <img class="mx-2 paywith__currency-icon" :src="currency.icon" :alt="currency.name" />
                  <div class="paywith__currency-name">
                    <div class="">{{ currency.name }}</div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
          <CustomButton :name="$t('bank-connect.connect-account')"
            className="tab-data__connect-bank__btn button-default-outline" @handle-click="getConnectBank()" />
        </div>
      </div>
      <div v-if="Object.values(conversionRate).length && Object.values(displayCurrency).length"
        class="d-flex justify-content-end align-items-center my-3">
        <div class="tab-data__bank-you-pay">
          {{ $t('payment.you-pay') }}
        </div>
        <div
          v-if="cart.amount && getConversionRate && conversionRate?.currentRate && Object.values(conversionRate).length"
          class="tab-data__bank-amount">
          {{ NumberFormat(
            DecimalNumber(cart.amount)
              .mul(getConversionRate)
              .div(DecimalNumber(conversionRate.currentRate))) }}
          {{ String(selectedAccount.currency).toUpperCase() }}
        </div>
        <div v-else class="cs-payment__amount">
          $ {{ NumberFormat(cart.amount) }}
        </div>
      </div>
      <div class="tab-data__bank-error mb-2" v-if="error">
        {{ error }}
      </div>
      <div class="tab-data__bank-info mt-4" v-if="dwolla && dwolla.accounts && dwolla.accounts.length">
        <span>
          <img src="@/assets/img/info-payment.svg" />
        </span>
        <small>
          {{ $t('unauth-payment.info-bank') }}
        </small>
      </div>
      <CustomButton :disabled="getDisableStatus" :name="$t('payment.pay-with-bank')" className="button-default w-100"
        @handle-click="payment()" class="continue-btn mt-3" :showLogo="marketInfo && !marketInfo.whiteLabel">
        <img class="cs-btn__img" src="@/assets/img/logo-white.svg" alt="logo">
      </CustomButton>
    </div>
    <div v-else class="min-height paywith__loader pt-3 d-flex justify-content-center">
      <b-spinner label="Loading..." />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  GET_BANKS, PURCHASE, SET_ACCOUNT,
  SET_RESULT_PAGE_DATA,
  USER_TRACK_EVENTS,
} from '@/store/modules/user/consts';
// import Loading from '@/components/Loading.vue';
import CustomButton from '../views/customButton.vue';
import helper, { isUSD } from '../utils/helper';
import { transactionSourceEnum } from '../store/modules/user/enums';

export default {
  name: 'BankComponent',
  components: {
    CustomButton,
    // Loading,
  },
  props: {
    rootConvertedData: Object || {},
  },
  data() {
    return {
      dwolla: {},
      selectedAccount: {},
      accountsListControl: false,
      currencyListControl: false,
      resultData: {
        // eslint-disable-next-line
        icon: require('@/assets/img/success.svg'),
        title: this.$t('result.success'),
        description: this.$t('result.bank-success-text'),
      },
      selectedCurrency: {},
      cartData: {},
      error: '',
      isLoading: false,
    };
  },
  computed: {
    getConversionRate() {
      if (!Number.isNaN(this.rootConvertedData.conversionRate)) {
        if (!Number.isNaN(this.cart.conversionRate)) {
          return this.cartData.conversionRate !== this.rootConvertedData.conversionRate
            ? this.rootConvertedData.conversionRate : this.cart.conversionRate;
        }

        return this.rootConvertedData.conversionRate;
      }
      if (!Number.isNaN(this.cart.conversionRate)) {
        return this.cart.conversionRate;
      }
      return 1;
    },
    getFilteredAccounts() {
      if (this.dwolla.accounts) {
        return this.dwolla.accounts.filter(
          (v) => v.id !== (this.selectedAccount ? this.selectedAccount.id : ''),
        );
      } return [];
    },
    getFilteredCurrencies() {
      if (this.currencyOptions) {
        return this.currencyOptions.filter(
          (v) => v.value.toLowerCase() !== (this.selectedCurrency
            ? this.selectedCurrency.value : ''),
        );
      } return [];
    },
    ...mapGetters({
      cart: 'user/cart',
      displayCurrency: 'user/displayCurrency',
      marketInfo: 'user/marketInfo',
      userInfo: 'user/userInfo',
      currencies: 'user/currencies',
      bankAccount: 'user/bankAccount',
    }),
    getDisableStatus() {
      if (this.dwolla
        && this.dwolla.accounts
        && !this.dwolla.accounts.length) {
        return true;
      }
      return false;
    },
    currencyOptions() {
      const currencies = [];
      let icon;
      this.currencies.forEach((currency) => {
        if (currency.isFiat) {
          icon = '';
          if (isUSD(currency.id)) {
            currencies.unshift({
              name: currency.fullTitle,
              value: currency.id.toLowerCase(),
              icon,
            });
          }
        }
      });
      return currencies;
    },
    conversionRate() {
      let rate = {};
      this.currencies.forEach((item) => {
        if (this.selectedAccount?.currency) {
          if (item.id.toLowerCase() === this.selectedAccount.currency.toLowerCase()) {
            rate = item;
          }
        }
      });
      return rate;
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.fetchBanks();

    if (this.$route.params && Object.keys(this.$route.params).length) {
      this.selectedAccount = this.$route.params.bankClicked;
    } else if (this.bankAccount && Object.keys(this.bankAccount).length) {
      this.selectedAccount = this.bankAccount;
    }

    this.isLoading = false;
  },
  methods: {

    async fetchBanks() {
      try {
        const resp = await this.$store.dispatch(`user/${GET_BANKS}`, { source: transactionSourceEnum.BANK });
        this.dwolla = resp.banks.find((el) => el.value === 'dwolla');

        if (this.dwolla) {
          this.$store.commit(
            'user/setSessionNotifyStatus',
            {
              isBankLinked: true,
            },
          );
        }
        this.selectedCurrency = this.currencyOptions.find(
          (el) => el.value.toLowerCase() === helper.getLowerCase(resp.defaultCurrency),
        );
        // eslint-disable-next-line prefer-destructuring
        this.selectedAccount = this.dwolla.accounts[0];
        if (this.selectedAccount) {
          window.EventBus.emit('showModal');
        }
      } catch (Err) {
        console.log(Err);
      }
    },
    getConnectBank() {
      this.$router.push({ name: 'AddBank' });
    },
    async payment() {
      this.$emit('setLoader', true);
      const cartData = {
        clientId: this.cart.merchant_id,
        amount: this.cart.amount,
        // eslint-disable-next-line no-nested-ternary
        accountId: this.selectedAccount ? this.selectedAccount.id : '',
        cart: this.cart.cart,
        stockId: this.dwolla.stockId,
        offerId: this.cart.order,
        confirmation: this.cart.encrypted || '',
        merchantStoreCurrency: this.cart.currency,
        hostedPageId: this.cart.uuid || '',
        shippingAddress: this.cart.shippingAddress ? this.cart.shippingAddress : null,
      };
      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: 'Bank',
          activity: 'Pay with Bank clicked',
          meta: {
            name: this.selectedAccount.bankName,
          },
        },
      });
      this.error = '';
      this.$nextTick(async () => {
        this.$emit('setLoader', true);
        if (this.userInfo.is2faEnabled) {
          const payload = this.Encrypt(JSON.stringify(cartData));
          this.$router.push({ name: 'Rocketfuel Verify', params: { data: payload } });
        } else {
          const res = await this.$store.dispatch(
            `user/${PURCHASE}`,
            { data: this.Encrypt(cartData), code2fa: '', source: transactionSourceEnum.BANK },
          );
          if (res.status === 'ok') {
            this.$store.commit('auth/changePaymentCompleted');
            await this.$store.commit('user/clearCart');
            this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
              moduleInfo: {
                current: 'Bank',
                activity: 'Pay with Bank success',
                meta: {
                  name: this.selectedAccount.bankName,
                },
              },
            });
            if (this.userInfo && this.userInfo.ssoStatus) {
              this.$router.push({ name: 'Thank' });
            } else {
              this.$store.dispatch(`user/${SET_RESULT_PAGE_DATA}`, this.resultData);
              this.$router.push({ name: 'Result' });
            }
          } else if (res.status === 'error') {
            this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
              moduleInfo: {
                current: 'Bank',
                activity: 'Pay with Bank failed',
                meta: {
                  name: this.selectedAccount.bankName,
                },
                error: res.response,
              },
            });
            this.error = res.response;
          }
        }
        this.isLoading = false;
      });
    },
    handelSelectAccount(val) {
      this.selectedAccount = val;
      this.accountsListControl = false;
      this.$store.dispatch(`user/${SET_ACCOUNT}`, val);
    },
    handelSelectCurrency(val) {
      this.selectedCurrency = val;
      this.currencyListControl = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-data {
  &__img {
    width: 80px;
  }

  &__connect-bank {
    p {
      font-size: 12px;
      color: #1E1C41;
      text-align: center;
    }

    &__btn {
      width: 60%;
      margin: 10px auto;
      padding: 2px;
      font-size: 14px
    }
  }

  &__bank {
    &-info {
      display: flex;
      background: #fff;
      border: 1px solid #D7D8D6;
      padding: 12px 8px;
      border-radius: 4px;
      color: #6B7390;
      line-height: 15px;

      span {
        margin-right: 10px;

        img {
          width: 25px;
        }
      }
    }

    &-error {
      width: 100%;
      color: #f53d3d;
      font-size: 12px;
      line-height: 1.2;
      min-height: 16px;
      font-weight: 400;
    }

    &-you-pay {
      font-weight: 300;
      font-size: 16px;
      line-height: 27px;
    }

    &-amount {
      font-weight: 800;
      font-size: 23px;
      line-height: 38px;
      margin-left: 10px;
    }
  }
}

.paywith {
  width: 100%;
  margin-bottom: 10px;

  // justify-content: space-between;
  // cursor: pointer;
  &__spinner {
    margin-right: 6px;
    width: 15px;
    height: 15px;
  }

  &__text_blue {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ededee;
    color: #1B1F3B;
    padding: 10px;
    width: 30%;
    line-height: 15px;
    border-left: 4px solid #5e72e4;
  }

  &__text_orange {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ededee;
    color: #1B1F3B;
    padding: 10px;
    width: 30%;
    line-height: 15px;
    border-left: 4px solid #ff7a00;
  }

  &__container {
    padding: 5px 10px;
    align-items: center;
    display: flex;
    flex-grow: 1;

    img {
      width: 1.5em;
      height: 1.5em;
    }

    span {
      font-size: 14px;
      padding: 0 10px;
      text-transform: capitalize;
    }
  }

  &__container-block {
    padding: 5px 10px;
    display: flex;
    flex-flow: column;
    flex-grow: 1;
    font-size: 12px;

    // margin-bottom: 15px;
    img {
      width: 2.25em;
      height: 2.25em;
    }

    span {
      padding: 0 10px;
      text-transform: capitalize;
    }

    .search-wrapper {
      position: relative;
      display: flex;
      width: 160px;

      .search-input {
        width: 100%;
        border: 1px solid #ededee;
        padding: 5px;
        font-size: 14px;
        color: #1B1F3B;

        &::placeholder {
          font-size: 14px;
          color: #ededee;
        }
      }

      .clear-data {
        cursor: pointer;

        img {
          display: inline-block;
          position: absolute;
          width: 8px;
          // right: 8px;
          // top: 12px;
        }
      }
    }
  }

  &__loader {
    flex-grow: 1;
    align-items: center;
    font-size: 12px;
  }

  .connect {
    font-size: 12px;
    padding: 0 10px;
  }

  &__droparrow {
    padding: 5px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    position: absolute;
    right: -15px;

    .dropdown-arrow {
      margin-left: 5px;

      img {
        width: 0.7em;
        width: 0.7em;
      }
    }
  }

  &__arrow {
    padding: 5px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    .dropdown-arrow {
      margin-left: 5px;

      img {
        width: 0.7em;
        width: 0.7em;
      }
    }
  }

  &__bank-name {
    font-size: 14px;
    font-weight: 600;

    &__item {
      width: 60vw;
      overflow: hidden;
      text-overflow: ellipse;
    }
  }

  &__account {
    font-size: 12px;

    &-text {
      color: grey;
    }
  }

  &__currency {
    &-icon {
      width: 30px;
      height: 30px;
    }

    &-name {
      font-size: 14px;
    }
  }
}

.connect-text {
  align-items: center;
  width: 100%;
  font-size: 14px;
}

.min-height {
  min-height: 100px;
}
</style>
